import { Tabs } from "antd";
import i18n from "../../../../../utils/i18n";
import MarketValueTable from "./market-value-table";
import NetIncomeTable from "./net-income-table";

const { TabPane } = Tabs;

enum TabKeyEnum {
    Variables = "1",
    AssetClasses = "2",
}

const tabs = [{
    key: TabKeyEnum.Variables,
    name: i18n.t("AssetLiability.marketRisk"),
    content: <MarketValueTable />
},
{
    key: TabKeyEnum.AssetClasses,
    name: i18n.t("AssetLiability.netIncomeRisk"),
    content: <NetIncomeTable />
}]


const DynamicALM = () => {
    const tabChanged = (activeTab: TabKeyEnum) => {
    }

    return (
        <div className="approval-workflow-wrapper">
            <Tabs defaultActiveKey={TabKeyEnum.Variables} onChange={activeKey => { tabChanged(activeKey as TabKeyEnum) }}>
                {tabs.map((item) =>
                    <TabPane
                        tab={<>{item.name}</>}
                        key={item.key}>
                    {item.content}
                    </TabPane>)}
            </Tabs>
        </div>
    )
}

export default DynamicALM;